import React, { useState } from 'react';
import { Modal, Button, Toast, ToastContainer } from 'react-bootstrap';
import { BsCopy } from 'react-icons/bs';

const K3ModalViewSource = ({ show, onHide, data, title = "Source" }) => {
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');

  const handleCopy = () => {
    if (data) {
      navigator.clipboard.writeText(JSON.stringify(data, null, 2));
      setToastMessage('Source copied to clipboard!');
      setShowToast(true);
      setTimeout(() => setShowToast(false), 3000);
    }
  };

  return (
    <>
      <Modal show={show} onHide={onHide} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {data && (
            <div style={{ position: 'relative' }}>
              <pre className="bg-light p-3 rounded" style={{ maxHeight: '60vh', overflow: 'auto' }}>
                {JSON.stringify(data, null, 2)}
              </pre>
              <Button 
                variant="outline-secondary" 
                onClick={handleCopy}
                style={{
                  position: 'absolute',
                  right: '10px',
                  top: '10px',
                  padding: '0.25rem 0.5rem',
                  border: 'none',
                  background: 'transparent'
                }}
              >
                <BsCopy />
              </Button>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer className="justify-content-end">
          <Button variant="secondary" onClick={onHide}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <ToastContainer position="top-end" className="p-3">
        <Toast 
          show={showToast} 
          onClose={() => setShowToast(false)}
          bg="success"
          delay={3000}
          autohide
        >
          <Toast.Header closeButton={false}>
            <strong className="me-auto">Success</strong>
          </Toast.Header>
          <Toast.Body className="text-white">
            {toastMessage}
          </Toast.Body>
        </Toast>
      </ToastContainer>
    </>
  );
};

export default K3ModalViewSource; 